/*
  « Ajouter au panier » directement depuis une rangée de produits (rayon érable).

  On passe par le même événement que le formulaire produit du thème
  (CartLinesUpdateEvent) : la pastille du panier se met à jour et le panier
  latéral s'ouvre tout seul, exactement comme sur une fiche produit.
  Fonctionne aussi sur les cartes recopiées par le carrousel (clic délégué).
*/
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.cblAjoutRapide) {
  window.cblAjoutRapide = true;

  document.addEventListener('click', async (e) => {
    const bouton = e.target.closest('[data-cbl-ajouter]');
    if (!bouton || bouton.getAttribute('aria-busy')) return;
    e.preventDefault();

    const id = bouton.dataset.cblAjouter;
    const texte = bouton.textContent;
    bouton.setAttribute('aria-busy', 'true');

    const donnees = new FormData();
    donnees.set('id', id);
    donnees.set('quantity', '1');
    const sections = [...document.querySelectorAll('cart-items-component')]
      .map((c) => c.dataset.sectionId)
      .filter(Boolean);
    if (sections.length) donnees.set('sections', sections.join(','));

    const promesse = CartLinesUpdateEvent.createPromise();
    bouton.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: id, quantity: 1 }],
        promise: promesse.promise,
      })
    );

    try {
      const reponse = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        body: donnees,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      }).then((r) => r.json());

      const panier = await fetch(`${Theme.routes.cart_url}.js`, {
        headers: { Accept: 'application/json' },
      }).then((r) => r.json());

      promesse.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(panier),
        detail: {
          items: panier.items,
          source: 'cbl-ajout-rapide',
          sourceId: id,
          itemCount: 1,
          sections: reponse.sections,
          didError: Boolean(reponse.status),
        },
      });

      if (reponse.status) throw new Error(reponse.description || reponse.message);
      bouton.textContent = '✓ Ajouté';
      bouton.classList.add('est-ajoute');
    } catch (erreur) {
      promesse.reject?.(erreur);
      bouton.textContent = 'Épuisé ou indisponible';
    } finally {
      bouton.removeAttribute('aria-busy');
      setTimeout(() => {
        bouton.textContent = texte;
        bouton.classList.remove('est-ajoute');
      }, 2200);
    }
  });
}
